module.exports = __webpack_public_path__ + "static/media/browser.bb744614.svg";